const route = [
  { // 注册页面
    path: '/register',
    name: 'user-register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/register.vue'),
  },
  { // 用户中心
    path: '/user-center',
    name: 'user-center',
    redirect: '/user-center/profile',
    component: () => import('@/views/user/center.vue'),
    children: [
      {
        path: 'profile',
        name: 'center-profile',
        component: () => import('@/views/user/profile.vue'),
      },
      {
        path: 'password',
        name: 'center-password',
        component: () => import('@/views/user/password.vue'),
      },
      {
        path: 'address',
        name: 'center-address',
        component: () => import('@/views/user/address.vue'),
      },
      {
        path: 'coupon',
        name: 'center-coupon',
        component: () => import('@/views/user/coupons.vue'),
      },
      {
        path: 'integral',
        name: 'center-integral',
        component: () => import('@/views/user/integral.vue'),
      },
      {
        path: 'order',
        name: 'center-order',
        component: () => import('@/views/user/order.vue'),
      },
    ],
  },
];

export default route;
